import BeforeAfterSlider from "../components/BeforeAfterSlider";
import CourtDesigner from "../components/CourtDesigner";
import { Reveal, Overline } from "../components/Reveal";
import { IMAGES } from "../data/content";
import Seo from "../components/Seo";

export default function Customiser() {
  return (
    <div className="pt-28 pb-24 min-h-screen noise">
      <Seo title="Court Designer — Design Your Court Online | Speedy Resurfacing"
           description="Design your dream court in 7 steps — surface, size, zone colours, game lines, logo and extras — then send it straight to Sydney's court resurfacing specialists for a free quote."
           path="/customiser" />
      <div className="mx-auto max-w-7xl px-5 md:px-10">
        <Reveal>
          <Overline>Speedy Resurfacing Court Designer</Overline>
          <h1 className="mt-5 font-heading font-black text-5xl md:text-7xl tracking-tighter">BUILD YOUR COURT.</h1>
          <p className="mt-5 max-w-xl text-zinc-400">
            Seven steps from idea to quote — surface system, true-to-scale sizing (or your exact slab), zone colours, game lines, centre logo and extras. Design it, see it live, send it to Team Speedy.
          </p>
        </Reveal>

        <div className="mt-14">
          <CourtDesigner />
        </div>

        <div className="mt-24">
          <Reveal>
            <Overline>Before | Proposed</Overline>
            <h2 className="mt-4 font-heading font-black text-3xl md:text-5xl tracking-tight mb-8">SEE THE TRANSFORMATION.</h2>
          </Reveal>
          <Reveal delay={0.1}>
            <BeforeAfterSlider before={IMAGES.worn} after={IMAGES.speedyBball} beforeLabel="BEFORE" afterLabel="PROPOSED" testid="customiser-slider" />
          </Reveal>
        </div>
      </div>
    </div>
  );
}
